export default "__VITE_ASSET__InNm9LQG__"